/**
 * Shows only the product images tagged for the currently selected color variant.
 *
 * Images are tagged in their alt text with an exact bracketed marker, e.g. "[light]",
 * "[dark]". Untagged images (no bracket at all) are treated as shared/generic and
 * always shown.
 *
 * This used to be a plain inline <script> rendered once inside the product page's
 * own markup. That broke inside the "Choose options" quick-view modal: the modal
 * fetches the real product page HTML and DOM-morphs it into an existing container,
 * and morphed-in <script> tags never execute (same as setting innerHTML). So the
 * filter simply never ran for quick-view, and both variants showed every image.
 *
 * Fix: load this once as a real script, sitewide, and react to two things instead
 * of a single DOMContentLoaded pass:
 *   1. 'change' events on color swatches, via delegation on document - works no
 *      matter when or where the swatch was added to the DOM.
 *   2. New product gallery markup landing in the DOM (a MutationObserver) - covers
 *      the quick-view modal's initial state, where no 'change' event ever fires
 *      because the pre-selected color's swatch was never actually toggled by hand.
 */
(function () {
  var COLOR_INPUT_SELECTOR = 'input[name*="Color"], input[name*="color"]';
  var MEDIA_ITEM_SELECTOR = 'li.product-media-container';
  var ANY_TAG_PATTERN = /\[[^\]]+\]/;

  function getCurrentColor(scope) {
    var inputs = scope.querySelectorAll(COLOR_INPUT_SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return inputs[i].value.toLowerCase().trim();
    }
    return '';
  }

  function findScope(el) {
    return (el.closest && el.closest('product-component')) || document;
  }

  function applyFilter(scope) {
    scope = scope || document;
    var mediaContainers = scope.querySelectorAll(MEDIA_ITEM_SELECTOR);
    if (!mediaContainers.length) return;

    var color = getCurrentColor(scope);
    var tag = '[' + color + ']';

    mediaContainers.forEach(function (container) {
      var img = container.querySelector('img');
      if (!img) return;

      var altText = (img.alt || '').toLowerCase().trim();
      var hasAnyTag = ANY_TAG_PATTERN.test(altText);
      var shouldShow = !color || altText === '' || !hasAnyTag || altText.indexOf(tag) !== -1;

      container.classList.toggle('variant-hidden', !shouldShow);
      if (shouldShow) {
        container.removeAttribute('data-variant-hidden');
      } else {
        container.setAttribute('data-variant-hidden', 'true');
      }
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(COLOR_INPUT_SELECTOR)) return;
    applyFilter(findScope(target));
  });

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var addedNodes = mutations[m].addedNodes;
      for (var n = 0; n < addedNodes.length; n++) {
        var node = addedNodes[n];
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches(MEDIA_ITEM_SELECTOR) || node.querySelector(MEDIA_ITEM_SELECTOR)) {
          applyFilter(findScope(node));
        }
      }
    }
  });

  function init() {
    applyFilter(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
